import barStachedBar from "assets/images/chart-images/stacked-bar.png";
import table from "assets/images/chart-images/table.png";
import barClusteredBarChart from "assets/images/chart-images/clustered-bar-chart.png";
import barHorizontalStackedBar from "assets/images/chart-images/horizontal-stacked-bar.png";


const countriesList = [
        { id: "DFdCTDT-BVS01p", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DFdCTDT-BHS01p", name: "horizontal-stacked-bar", chartImage: barHorizontalStackedBar, disabled: false },
        { id: "DFdCTDT-CC01p", name: "clustered-bar", chartImage: barClusteredBarChart, disabled: false },
        { id: "DFdCTDT-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DFdCTDT-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },

        { id: "DFdCTCDT-BVS01p", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DFdCTCDT-BHS01p", name: "horizontal-stacked-bar", chartImage: barHorizontalStackedBar, disabled: false },
        { id: "DFdCTCDT-CC01p", name: "clustered-bar", chartImage: barClusteredBarChart, disabled: false },
        { id: "DFdCTCDT-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DFdCTCDT-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },
];

export default countriesList;
